import { CardBody } from '@statsbomb/kitbag-components';
import { MyPlaylists } from '@statsbomb/video-client-js';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useTrackVideoStart } from '@/analytics/snowplow/hooks/useTrackVideoStart';
import { userHasVideoAccessAtom } from '@/atoms/user';
import { CardHeightWrapper } from '@/components/card/CardHeightWrapper';
import { FullScreenCard } from '@/components/card/FullScreenCard';
import { PageTitle } from '@/components/head/PageTitle';
import { AppShellContents } from '@/components/layout/AppShell';
import { ContactSupportStatusDescription } from '@/components/support/ContactSupportCard';
import { TopBar } from '@/components/topBar/TopBar';
import { TopBarHeading } from '@/components/topBar/TopBarHeading';
import { VideoAuthAndKeyboardWrapper } from '@/components/VideoProvider';
import { StatusType } from '@/types/status';
import { EmptyPlaylistContent } from '../components/video/EmptyPlaylistContent/EmptyPlaylistContent';

export const VideoPlaylists = () => {
  useTrackVideoStart();
  const { t } = useTranslation(['navigation', 'preferences', 'error']);
  const userHasVideoAccess = useAtomValue(userHasVideoAccessAtom);

  return (
    <>
      <PageTitle>{t('primary.playlists')} </PageTitle>
      <AppShellContents
        topBar={
          <TopBar>
            <TopBarHeading>{t('primary.playlists')}</TopBarHeading>
          </TopBar>
        }
      >
        <FullScreenCard>
          {userHasVideoAccess ? (
            <CardBody>
              <VideoAuthAndKeyboardWrapper>
                <MyPlaylists emptyStateContent={<EmptyPlaylistContent />} enableSendWholePlaylistToHudl hideHeader />
              </VideoAuthAndKeyboardWrapper>
            </CardBody>
          ) : (
            <CardHeightWrapper>
              <CardBody
                statusType={StatusType.error}
                statusTitle={t('no_video_access.title', { ns: 'error' })}
                statusDescription={
                  <ContactSupportStatusDescription
                    description={`${t('no_video_access.message', { ns: 'error' })}${' '}`}
                    linkText={t('no_video_access.linkMessage', { ns: 'error' })}
                  />
                }
              />
            </CardHeightWrapper>
          )}
        </FullScreenCard>
      </AppShellContents>
    </>
  );
};
